/*
 * A wrapper for a value.
 *
 * The value is typically provided by the backend and can be explicitly reset
 * to reload it from the backend. During this invalidation, the previous value
 * is still visible in "value". This often simplifies frontend logic which can
 * then essentially use the following pattern:
 *
 * <div>{{ buffered.value }}</div>
 *
 * async onClick() {
 *   show spinner;
 *   // The buffered.value is going to show the previous value until the promise resolves
 *   // and the buffered.value is updated.
 *   await invalidate();
 *   hide spinner;
 * }
 */
export interface IBuffered<T> {
	value: T | null
	invalidate(until?: Promise<unknown>): Promise<void>
}

/*
 * A type guard for IBuffered, i.e., return whether obj is an IBuffered.
 */
export function isIBuffered<T>(obj: any): obj is IBuffered<T> {
	return obj && typeof obj === "object" && "value" in obj;
}
